import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
  selector: 'ubi-layout-list-detail',
  templateUrl: './ubiLayoutListDetail.component.html',
  styleUrls: ['./ubiLayoutListDetail.component.scss']
})
export class UbiLayoutListDetailComponent implements OnInit {

  @Input() status: any;

  @Output()
  new = new EventEmitter();

  @Output()
  search = new EventEmitter();

  @Output()
  nextPage = new EventEmitter();

  @Output()
  save = new EventEmitter();

  @Output()
  delete = new EventEmitter();

  @Output()
  cancel = new EventEmitter();

  searchControl: FormControl = new FormControl();

  closeResult: string;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {

    this.searchControl.valueChanges
      .debounceTime(500)
      .distinctUntilChanged()
      .map(searchTerm => {
        this.search.emit(searchTerm);
      })
      .subscribe();

  }

  public newClick(event) {
    this.new.emit(true);
  }

  public saveClick(event) {
    this.save.emit(true);
  }

  public deleteClick(content) {

    this.modalService.open(content, { backdrop: 'static', keyboard: false }).result.then((result) => {
      if (result === 'Delete') {
        this.delete.emit(true);
      }
    });

  }

  public cancelClick(event) {
    this.cancel.emit(true);
  }

  public searchClick(event) {
    this.search.emit(this.searchControl.value);
  }

  public onScroll() {
    this.nextPage.emit();
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiLayoutListDetail/ubiLayoutListDetail.component.ts